import type { ContentFeedEntryResolved } from './content-feed.types.ts';

export type ContentSource = ContentFeedEntryResolved['source'];

/**
 * Excludes entries that do not have a match object.
 * When includeNearbyEntries is used, all relevant entries should have one.
 * This is a defensive client-side check.
 */
export const filterByMatch = (
  entries: ContentFeedEntryResolved[],
): ContentFeedEntryResolved[] => {
  return entries.filter((entry) => entry.match != null);
};

/**
 * Evaluate the minimum threshold.
 * Feed renders only if >= 3 entries AND at least one is community.
 */
export const evaluateThreshold = (
  entries: ContentFeedEntryResolved[],
): boolean => {
  if (entries.length < 3) {
    return false;
  }

  return entries.some((entry) => entry.source === 'community');
};
